module.exports = __webpack_public_path__ + "static/alexwork4-f6feee4783e85d9ada767c86302094e7.jpg";